<template>

    <div>

        <toolbar :title="'Weitere Apps'"></toolbar>

        <v-divider></v-divider>

        <template>
          <v-progress-linear v-if="timeToWait === true" color="red" :indeterminate="true"></v-progress-linear>
        </template>

        <v-layout row wrap v-if="thereIsAnError">
            <v-responsive>
                <v-card-text >
                    <v-flex xs12>
                        Die Daten konnten nicht abgerufen werden. Fehler 404.
                    </v-flex>
                </v-card-text>
            </v-responsive>
        </v-layout>

        <v-list v-if="apps">

            <template v-for="(item, index) in apps">

                <v-list-tile
                      avatar
                      :key="item.title"
                >
                    <v-list-tile-avatar>
                        <v-img v-if="item.icon" :src="(typeof item.icon !== 'undefined') ? item.icon : require('@/assets/logo.png')" contain></v-img>
                    </v-list-tile-avatar>

                    <v-list-tile-content style="width: 100px">
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        <!--<v-list-tile-sub-title>{{ item.info }}</v-list-tile-sub-title>-->
                    </v-list-tile-content>

                    <v-list-tile-action v-if="item.link">
                        <v-btn icon ripple target="_blank" title="Website öffnen" :href="item.link">
                            <v-icon class="icon-new-tab"></v-icon>
                        </v-btn>
                    </v-list-tile-action>

                    <v-list-tile-action v-if="! item.link">
                        <span style="opacity: 0.3">Bald</span>
                    </v-list-tile-action>

                </v-list-tile>

                <v-divider
                      v-if="(index+1) < apps.length"
                      :key="item.title+'divider'"
                >
                </v-divider>

            </template>

        </v-list>

    </div>

</template>

<script>
    export default {
        name: 'apps',
        data: () => ({
            apps: null,
            timeToWait: false,
            thereIsAnError: false
        }),

        computed: {


        },

        beforeCreate() {

            const vu = this;
            let myTimeout = window.setTimeout(function(){
                vu.timeToWait = true;
            }, 1500);

            this.axios.get("https://apiv1.software-schiek.de/apps/mwst")
                .then(response => {
                    if ( response.status === 200 && typeof( response.data ) === "object"  ) {
                        window.clearTimeout(myTimeout);
                        vu.timeToWait = false;
                        this.apps = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    vu.timeToWait = false;
                    vu.thereIsAnError = true;
                    window.clearTimeout(myTimeout);
                })

        }
    }
</script>

<style scoped>

</style>
